module.exports = __webpack_public_path__ + "img/logo-jkt.5ffeb19e.png";